export default __webpack_public_path__ + "static/tmc-black-orange-f912a8987fc57fc085e6b5775fe5c51c.svg";